<template>
  <div id="user">
    <el-tabs tab-position="left" @tab-click="chooseTab">
      <el-input
          size="mini"
          placeholder="输入人员姓名或部门名称"
          v-model="filterText">
        </el-input>
      <el-tab-pane label="按部门">
        <el-scrollbar style="height:350px;">
        
        <el-tree
          :data="treeList[0]"
          show-checkbox
          :props="defaultProps"
          :render-content="renderContent"
          node-key="value"
          ref="tree_0"
          :highlight-current="true"
          :default-expanded-keys="defaultShowNodes"
          :filter-node-method="filterNode"
        ></el-tree>
        </el-scrollbar>
      </el-tab-pane>

      <el-tab-pane label="按岗位">
        <el-scrollbar style="height:350px;">
        <el-tree
          :data="treeList1"
          show-checkbox
          :props="defaultProps"
          :render-content="renderContent"
          node-key="value"
          ref="tree_1"
          :filter-node-method="filterNode"
        ></el-tree>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>

    <el-button type="primary" @click="initUser">我已选定</el-button>
  </div>
</template>
<script>
export default {
  name: "user",
  props: ["userSelectData"],
  watch: {
    userSelectData: function(newObj, oleObh) {
      this.$refs["tree_0"].setCheckedKeys(newObj);
      this.$refs["tree_1"].setCheckedKeys(newObj);
    },
    filterText(val) {
      this.$refs["tree_0"].filter(val);
      this.$refs["tree_1"].filter(val);
    }
  },
  data() {
    return {
      defaultShowNodes: ['1'],
      filterText: '',
      data: [],
      roleList: [],
      treeList: "",
      treeList1: [],
      selectTab: 0,
      defaultProps: {
        children: "children",
        label: "label"
      },
    };
  },

  mounted: function() {
    var _self = this;
    this.$axios.get("/user/getAllUserTree?roleIds=0").then(res => {
      _self.treeList = res.data["treeMap"];
      _self.roleList = res.data["roleList"];
      _self.treeList1 = res.data['roleUserTree'];
      _self.$refs["tree_0"].setCheckedKeys(_self.userSelectData);
      _self.$refs["tree_1"].setCheckedKeys(_self.userSelectData);
    });
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    initUser() {
      let resList = []
      let listTemp = []
      var checkedNodes = this.$refs["tree_0"].getCheckedNodes();
      if(this.selectTab == 1){
        checkedNodes = this.$refs["tree_1"].getCheckedNodes();
      }
      for (var i = 0; i < checkedNodes.length; i++) {
        // 只取用户，且去重
        if (checkedNodes[i].id.indexOf("U-") >= 0 && listTemp.indexOf(checkedNodes[i].value) < 0) {
          resList.push({
            id: checkedNodes[i].value,
            name: checkedNodes[i].label
          });
          listTemp.push(checkedNodes[i].value)
        }
      }
      this.filterText = '';
      this.$emit("userSelect", resList);
    },
    chooseTab(data){
      this.selectTab = data.index;
    },
    //handleNodeCheck(data, node) {
    //},
    renderContent(h, { node, data, store }) {
      if (data.parentId == "D-0") {
        return (
          <span class="custom-tree-node">
            <i class="el-icon-s-home"></i>
            <span style="margin-left:5px;">{node.label}</span>
          </span>
        );
      } else {
        return (
          <span class="custom-tree-node">
            <i class={data.icon}></i>
            <span style="margin-left:5px;">{node.label}</span>
          </span>
        );
      }
    }
  }
};
</script>
<style  scoped>
/deep/
.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/userSelect.vue